import { PagedResult } from 'src/app/shared/model/generic-paged-result.model';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DashboardService } from 'src/app/dashboard/shared/dashboard.service';
import { DashboardReportDto } from 'src/app/dashboard/shared/dashboard-report.dto';
import { DashboardReportSearchDto } from 'src/app/dashboard/shared/dashboard-report-search.dto';
import { AuthService } from 'src/app/shared';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';

@Component({
  selector: 'wl-dashboard-neo-reports',
  templateUrl: './dashboard-neo-reports.component.html',
  styleUrls: ['./dashboard-neo-reports.component.less'],
  providers: [DashboardService],
  encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DashboardNeoReportsComponent implements OnInit {
  public searchParams: DashboardReportSearchDto;
  public searchResults: PagedResult<DashboardReportDto>;

  public constructor(
    private _dashboardService: DashboardService,
    private _authService: AuthService,
    private _navigationService: NavigationService
  ) {
    this.searchParams = new DashboardReportSearchDto();
    this.searchParams.PageSize = 10;
    this.searchResults = new PagedResult<DashboardReportDto>();
  }

  ngOnInit() {
    this._authService.getUserInfo().then((user) => {
      this.searchParams.UserNum = +(user.wli_usernum ?? 0);
      this.loadReports();
    });
  }

  public loadReports() {
    this._dashboardService.searchDashboardReports(this.searchParams).then((data) => {
      this.searchResults = data;
    });
  }

  public onPagingEvent(page: number) {
    this.searchParams.PageNumber = page;
    this.loadReports();
  }

  public openReport(report: DashboardReportDto) {
    this._navigationService.navigateToReport(report.ReportPath);
  }
}
